import { CartUpdatedEvent, ThemeEvents } from '@theme/events';

// NBO: apply NBO-WORLDWIDE automatically so customers don't have to copy the code.
// Skipped when the cart already has a code (e.g. an affiliate's own code), and for the rest
// of the visit once the customer removes NBO-WORLDWIDE or replaces it with another code.
const CODE = 'NBO-WORLDWIDE';
const OFF_KEY = 'nbo-auto-discount-off';
let running = false;

function isOff() {
  try {
    return sessionStorage.getItem(OFF_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function postCartUpdate(body) {
  return fetch(Theme.routes.cart_update_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((response) => response.json());
}

async function applyAutoDiscount() {
  if (running || isOff()) return;
  running = true;

  try {
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((response) =>
      response.json(),
    );
    if (!cart.item_count || (cart.discount_codes || []).length > 0) return;

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && drawer.dataset.sectionId ? drawer.dataset.sectionId : '';
    const data = await postCartUpdate({ discount: CODE, sections });

    const applied = (data.discount_codes || []).some((discount) => discount.code.toUpperCase() === CODE && discount.applicable);
    if (!applied) {
      // not valid for this cart or market: take it off again so no unusable code shows
      await postCartUpdate({ discount: '' });
      try {
        sessionStorage.setItem(OFF_KEY, '1');
      } catch (error) {}
      return;
    }

    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CartUpdatedEvent({}, { source: 'nbo-auto-discount', sections: data.sections }));
  } catch (error) {
    console.error('NBO auto discount:', error);
  } finally {
    running = false;
  }
}

document.addEventListener(ThemeEvents.cartUpdated, (event) => {
  if (event.detail?.data?.source === 'nbo-auto-discount') return;
  applyAutoDiscount();
});

applyAutoDiscount();
